import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useMyGames } from "@seabrookstudios/pitch2table";
import { Features } from "../games/features";
import nestifyzLogo from "../nestifyz/nestifyz.svg";
import { NestiFyzMigrationTool } from "../settings/NestifyzMigrationTool";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";

export const NestifyzMigrationCard = () => {
  const { data: games = [], isLoading } = useMyGames();

  if (!Features.NestiFyzMigration || isLoading || games.length > 0) {
    return null;
  }

  return (
    <Card variant="outlined">
      <CardHeader avatar={<CardMedia component="img" image={nestifyzLogo} alt="NestiFyz" />} />
      <CardContent>
        <Typography>
          Migrating from NestiFyz? Upload your export and pick up where you left off. You can also find the NestiFyz
          migration tool in the settings menu.
        </Typography>
      </CardContent>
      <CardActions>
        <NestiFyzMigrationTool
          CustomControl={
            <Button variant="contained" size="large">
              Start Import
            </Button>
          }
        />
      </CardActions>
    </Card>
  );
};
